import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.checklist.respond');
import { OnInit, OnDestroy, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

interface AnswerData {
    value: string;
    opinion: string;
    repair_needed: string;
    grade: string;
    not_applicable: boolean;
    rating: string;
}

interface SportsGroup {
    title: string;
    good_multiplier: number;
    fair_multiplier: number;
    poor_multiplier: number;
    sections: any[];
    totalItems: number;
}

// 정기안전점검 점수 산정 상수
const GRADE_VALUES: { [key: string]: number } = { a: 10, b: 8, c: 5, d: 2, e: 0 };
const INSPECTION_CATEGORY_WEIGHTS: { [key: string]: number } = {
    '주요시설': 60,
    '일반시설': 20,
    '부대시설': 20,
};

const INSPECTION_NOTES: { [key: string]: string[] } = {
    bridge: [
        '※ 평가항목 중 해당없는 항목은 해당없음란에 체크(✓)한다.',
        '※ 평가결과는 A(양호), B(경미한 결함), C(결함 있음), D(긴급 결함), E(사용금지)로 평가하며, 해당등급에 체크(✓)한다.',
        '※ 종합안전등급은 상태평가 결과와 안전성평가 결과를 종합하여 결정한다.',
        '※ 기존 점검/진단 결과 또는 보수/보강이력 등을 참고하여 점검에 임한다.',
    ],
    tunnel: [
        '※ 평가항목 중 해당없는 항목은 해당없음란에 체크(✓)한다.',
        '※ 평가결과는 A(양호), B(경미한 결함), C(결함 있음), D(긴급 결함), E(사용금지)로 평가하며, 해당등급에 체크(✓)한다.',
        '※ 종합안전등급은 상태평가 결과와 안전성평가 결과를 종합하여 결정한다.',
        '※ 기존 점검/진단 결과 또는 보수/보강이력 등을 참고하여 점검에 임한다.',
    ],
    retaining_wall: [
        '※ 평가항목 중 해당없는 항목은 해당없음란에 체크(✓)한다.',
        '※ 평가결과는 A(양호), B(경미한 결함), C(결함 있음), D(긴급 결함), E(사용금지)로 평가하며, 해당등급에 체크(✓)한다.',
        '※ 종합안전등급은 상태평가 결과와 안전성평가 결과를 종합하여 결정한다.',
        '※ 기존 점검/진단 결과 또는 보수/보강이력 등을 참고하여 점검에 임한다.',
    ],
    cut_slope: [
        '※ 평가항목 중 해당없는 항목은 해당없음란에 체크(✓)한다.',
        '※ 평가결과는 A(양호), B(경미한 결함), C(결함 있음), D(긴급 결함), E(사용금지)로 평가하며, 해당등급에 체크(✓)한다.',
        '※ 종합안전등급은 상태평가 결과와 안전성평가 결과를 종합하여 결정한다.',
        '※ 기존 점검/진단 결과 또는 보수/보강이력 등을 참고하여 점검에 임한다.',
    ],
    building: [
        '※ 평가항목 중 해당없는 항목은 해당없음란에 체크(✓)한다.',
        '※ 평가결과는 A(양호), B(경미한 결함), C(결함 있음), D(긴급 결함), E(사용금지)로 평가하며, 해당등급에 체크(✓)한다.',
        '※ 종합안전등급은 상태평가 결과와 안전성평가 결과를 종합하여 결정한다.',
        '※ 기존 점검/진단 결과 또는 보수/보강이력 등을 참고하여 점검에 임한다.',
    ],
};

@Component({
    selector: 'wiz-page-checklist-respond',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.checklist.respond/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageChecklistRespondComponent implements OnInit, OnDestroy {
    public responseId: string = '';
    public response: any = {};
    public checklist: any = {};
    public sections: any[] = [];
    public answers: { [itemId: string]: AnswerData } = {};

    // 양식 모드
    public isInspection: boolean = false;
    public isSports: boolean = false;
    public sportsGroups: SportsGroup[] = [];

    // 정기안전점검 점수 산정
    public inspectionScoreCategories: any[] = [];
    public inspectionTotalScore: number = 0;
    public inspectionGrade: string = '';

    // 하단 평가 정보
    public safetyGrade: string = '';
    public emergencyInspection: string = '';
    public safetyAction: string = '';
    public overallOpinion: string = '';
    public inspectorName: string = '';
    public inspectionDate: string = '';

    // 저장 상태
    public saving: boolean = false;
    public submitting: boolean = false;
    public lastSaved: string = '';
    public isSubmitted: boolean = false;

    private autoSaveTimer: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.responseId = WizRoute.segment.responseId || '';

        if (!this.responseId) {
            this.service.href('/checklist/list');
            return;
        }

        await this.loadResponse();
        await this.service.loading.hide();
        this.ref.detectChanges();
    }

    ngOnDestroy() {
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
    }

    public async loadResponse() {
        const { code, data } = await wiz.call('load_response', { response_id: this.responseId });
        if (code !== 200) {
            this.service.href('/checklist/list');
            return;
        }

        this.response = data.response;
        this.checklist = data.checklist;
        this.isInspection = data.checklist.form_type === 'inspection';
        this.isSports = data.checklist.form_type === 'sports';
        this.isSubmitted = data.response.status === 'submitted';

        // 섹션 + 항목
        this.sections = (data.sections || []).map((s: any) => ({
            ...s,
            group_title: s.group_title || '',
            good_multiplier: s.good_multiplier ?? 1,
            fair_multiplier: s.fair_multiplier ?? 0.6,
            poor_multiplier: s.poor_multiplier ?? 0.4,
            items: (s.items || []).map((item: any) => ({
                ...item,
                options: Array.isArray(item.options) ? item.options : [],
                points: item.points || 0,
            }))
        }));

        // 기존 답변 로드
        const rawAnswers = data.answers || {};
        this.answers = {};

        // 모든 항목에 대해 답변 초기화
        for (const section of this.sections) {
            for (const item of section.items) {
                if (rawAnswers[item.id]) {
                    this.answers[item.id] = {
                        value: rawAnswers[item.id].value || '',
                        opinion: rawAnswers[item.id].opinion || '',
                        repair_needed: rawAnswers[item.id].repair_needed || '',
                        grade: rawAnswers[item.id].grade || '',
                        not_applicable: !!rawAnswers[item.id].not_applicable,
                        rating: rawAnswers[item.id].rating || '',
                    };
                } else {
                    this.answers[item.id] = {
                        value: '',
                        opinion: '',
                        repair_needed: '',
                        grade: '',
                        not_applicable: false,
                        rating: '',
                    };
                }
            }
        }

        // 평가 정보
        this.safetyGrade = data.response.safety_grade || '';
        this.emergencyInspection = data.response.emergency_inspection || '';
        this.safetyAction = data.response.safety_action || '';
        this.overallOpinion = data.response.overall_opinion || '';
        this.inspectorName = data.response.inspector_name || '';
        this.inspectionDate = data.response.inspection_date || '';

        if (this.isSports) this.computeSportsGroups();
        if (this.isInspection) this.computeInspectionScore();
        this.ref.detectChanges();
    }

    // ==================== 답변 관리 ====================

    public getAnswer(itemId: string): AnswerData {
        if (!this.answers[itemId]) {
            this.answers[itemId] = {
                value: '',
                opinion: '',
                repair_needed: '',
                grade: '',
                not_applicable: false,
                rating: '',
            };
        }
        return this.answers[itemId];
    }

    public setGrade(itemId: string, grade: string) {
        const answer = this.getAnswer(itemId);
        if (answer.grade === grade) {
            answer.grade = '';
        } else {
            answer.grade = grade;
        }
        if (answer.not_applicable) {
            answer.not_applicable = false;
        }
        if (this.isInspection) this.computeInspectionScore();
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public toggleNotApplicable(itemId: string) {
        const answer = this.getAnswer(itemId);
        answer.not_applicable = !answer.not_applicable;
        if (answer.not_applicable) {
            answer.grade = '';
            answer.repair_needed = '';
        }
        if (this.isInspection) this.computeInspectionScore();
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public toggleRepairNeeded(itemId: string) {
        const answer = this.getAnswer(itemId);
        answer.repair_needed = answer.repair_needed === 'Y' ? '' : 'Y';
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public onOpinionInput(itemId: string) {
        this.scheduleAutoSave();
    }

    public onValueInput(itemId: string) {
        this.scheduleAutoSave();
    }

    // ==================== 스포츠 모드: 등급 선택 ====================

    public setRating(itemId: string, rating: string) {
        const answer = this.getAnswer(itemId);
        if (answer.rating === rating) {
            answer.rating = '';
        } else {
            answer.rating = rating;
        }
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    public getRatingLabel(rating: string): string {
        const map: any = { good: '양호', fair: '미흡', poor: '불량' };
        return map[rating] || rating;
    }

    // ==================== 스포츠 모드: 점수 계산 ====================

    public computeSportsGroups() {
        const groups: SportsGroup[] = [];
        let currentGroup: SportsGroup | null = null;
        for (const section of this.sections) {
            const gt = section.group_title || section.title;
            if (!currentGroup || currentGroup.title !== gt) {
                currentGroup = {
                    title: gt,
                    good_multiplier: section.good_multiplier ?? 1,
                    fair_multiplier: section.fair_multiplier ?? 0.6,
                    poor_multiplier: section.poor_multiplier ?? 0.4,
                    sections: [],
                    totalItems: 0,
                };
                groups.push(currentGroup);
            }
            currentGroup.sections.push(section);
            currentGroup.totalItems += section.items.length;
        }
        this.sportsGroups = groups;
    }

    public getItemScore(item: any, section: any): number {
        const answer = this.getAnswer(item.id);
        if (!answer.rating) return 0;
        const points = item.points || 0;
        const multiplierMap: any = {
            good: section.good_multiplier ?? 1,
            fair: section.fair_multiplier ?? 0.6,
            poor: section.poor_multiplier ?? 0.4,
        };
        return Math.round((points * (multiplierMap[answer.rating] || 0)) * 100) / 100;
    }

    public getGroupScore(group: SportsGroup): number {
        let total = 0;
        for (const section of group.sections) {
            for (const item of section.items) {
                total += this.getItemScore(item, section);
            }
        }
        return Math.round(total * 100) / 100;
    }

    public getGroupMaxScore(group: SportsGroup): number {
        let total = 0;
        for (const section of group.sections) {
            for (const item of section.items) {
                total += item.points || 0;
            }
        }
        return total;
    }

    public get sportsTotalScore(): number {
        let total = 0;
        for (const section of this.sections) {
            for (const item of section.items) {
                total += this.getItemScore(item, section);
            }
        }
        return Math.round(total * 100) / 100;
    }

    public get sportsTotalMaxScore(): number {
        return this.sections.reduce((sum: number, s: any) =>
            sum + s.items.reduce((is: number, item: any) => is + (item.points || 0), 0), 0);
    }

    public get sportsPercentage(): number {
        const max = this.sportsTotalMaxScore;
        if (max <= 0) return 0;
        return Math.round((this.sportsTotalScore / max) * 10000) / 100;
    }

    public get sportsGrade(): string {
        const pct = this.sportsPercentage;
        if (pct >= 95) return 'A';
        if (pct >= 85) return 'B';
        if (pct >= 65) return 'C';
        return 'D';
    }

    public sportsGradeColor(grade: string): string {
        const map: any = {
            'A': 'bg-emerald-600 text-white',
            'B': 'bg-blue-600 text-white',
            'C': 'bg-yellow-500 text-white',
            'D': 'bg-red-600 text-white',
        };
        return map[grade] || 'bg-slate-200 text-slate-500';
    }

    public getSportsItemNumber(groupIndex: number, sectionIndexInGroup: number, itemIndex: number): number {
        let count = 0;
        for (let gi = 0; gi < groupIndex; gi++) {
            count += this.sportsGroups[gi].totalItems;
        }
        for (let si = 0; si < sectionIndexInGroup; si++) {
            count += this.sportsGroups[groupIndex].sections[si].items.length;
        }
        return count + itemIndex + 1;
    }

    // ==================== 정기안전점검: 점수 산정 ====================

    public computeInspectionScore() {
        if (!this.isInspection) return;

        // 섹션을 카테고리(group_title 또는 title)별로 그룹핑
        const catMap = new Map<string, { sections: any[] }>();
        for (const section of this.sections) {
            const catTitle = section.group_title || section.title;
            if (!catMap.has(catTitle)) {
                catMap.set(catTitle, { sections: [] });
            }
            catMap.get(catTitle)!.sections.push(section);
        }

        const categories: any[] = [];
        for (const [title, data] of catMap.entries()) {
            let sum = 0, answered = 0, itemCount = 0, naCount = 0;
            for (const section of data.sections) {
                for (const item of section.items) {
                    itemCount++;
                    const answer = this.getAnswer(item.id);
                    if (answer.not_applicable) { naCount++; continue; }
                    if (answer.grade && GRADE_VALUES[answer.grade] !== undefined) {
                        sum += GRADE_VALUES[answer.grade];
                        answered++;
                    }
                }
            }
            categories.push({
                title,
                weight: INSPECTION_CATEGORY_WEIGHTS[title] || 0,
                avg: answered > 0 ? Math.round((sum / answered) * 100) / 100 : 0,
                hasData: answered > 0,
                answeredCount: answered,
                totalCount: itemCount,
                naCount,
                adjustedWeight: 0,
                weightedScore: 0,
            });
        }

        // 가중치 재분배: 데이터가 있고 가중치가 배정된 카테고리만 active
        const activeCategories = categories.filter((c: any) => c.hasData && c.weight > 0);
        const activeWeightSum = activeCategories.reduce((s: number, c: any) => s + c.weight, 0);

        for (const cat of categories) {
            if (cat.hasData && cat.weight > 0 && activeWeightSum > 0) {
                cat.adjustedWeight = Math.round(cat.weight * (100 / activeWeightSum) * 10) / 10;
                cat.weightedScore = Math.round(cat.avg * cat.adjustedWeight / 100 * 100) / 100;
            } else {
                cat.adjustedWeight = cat.weight;
                cat.weightedScore = 0;
            }
        }

        // 총점 계산 (0~10 범위)
        let totalScore = 0;
        if (activeWeightSum > 0) {
            for (const cat of activeCategories) {
                const adjustedWeight = cat.weight * (100 / activeWeightSum);
                totalScore += cat.avg * adjustedWeight / 100;
            }
        }
        this.inspectionTotalScore = Math.round(totalScore * 100) / 100;

        // 등급 결정
        if (this.inspectionTotalScore >= 7) this.inspectionGrade = 'A';
        else if (this.inspectionTotalScore >= 6) this.inspectionGrade = 'B';
        else if (this.inspectionTotalScore >= 5) this.inspectionGrade = 'C';
        else if (this.inspectionTotalScore >= 4) this.inspectionGrade = 'D';
        else this.inspectionGrade = 'E';

        // 안전등급 자동 업데이트
        this.safetyGrade = this.inspectionGrade;

        this.inspectionScoreCategories = categories;
    }

    public inspectionGradeColor(grade: string): string {
        const map: any = {
            'A': 'bg-emerald-600 text-white',
            'B': 'bg-blue-600 text-white',
            'C': 'bg-yellow-500 text-white',
            'D': 'bg-orange-600 text-white',
            'E': 'bg-red-600 text-white',
        };
        return map[grade] || 'bg-slate-200 text-slate-500';
    }

    // ==================== 전역 번호 매기기 ====================

    public getGlobalItemNumber(sectionIndex: number, itemIndex: number): number {
        let count = 0;
        for (let i = 0; i < sectionIndex; i++) {
            count += this.sections[i].items.length;
        }
        return count + itemIndex + 1;
    }

    public get totalItemCount(): number {
        return this.sections.reduce((sum: number, s: any) => sum + s.items.length, 0);
    }

    // ==================== 안내 문구 ====================

    public getInspectionNotes(): string[] {
        if (!this.isInspection || !this.checklist.facility_type) return [];
        return INSPECTION_NOTES[this.checklist.facility_type] || [];
    }

    // ==================== 저장 ====================

    public scheduleAutoSave() {
        if (this.isSubmitted) return;
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
        this.autoSaveTimer = setTimeout(() => this.save(), 3000);
    }

    public async save() {
        if (this.isSubmitted) return;
        this.saving = true;
        this.ref.detectChanges();

        const params: any = {
            response_id: this.responseId,
            answers: JSON.stringify(this.answers),
            safety_grade: this.safetyGrade,
            emergency_inspection: this.emergencyInspection,
            safety_action: this.safetyAction,
            overall_opinion: this.overallOpinion,
            inspector_name: this.inspectorName,
            inspection_date: this.inspectionDate,
        };
        if (this.isSports) {
            params.total_score = String(this.sportsTotalScore);
            params.max_score = String(this.sportsTotalMaxScore);
        }
        if (this.isInspection) {
            params.total_score = String(this.inspectionTotalScore);
            params.max_score = '10';
        }

        const { code } = await wiz.call('save_response', params);

        this.saving = false;
        if (code === 200) {
            const now = new Date();
            this.lastSaved = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;
        }
        this.ref.detectChanges();
    }

    public async submit() {
        this.submitting = true;
        this.ref.detectChanges();

        const params: any = {
            response_id: this.responseId,
            answers: JSON.stringify(this.answers),
            safety_grade: this.safetyGrade,
            emergency_inspection: this.emergencyInspection,
            safety_action: this.safetyAction,
            overall_opinion: this.overallOpinion,
            inspector_name: this.inspectorName,
            inspection_date: this.inspectionDate,
        };
        if (this.isSports) {
            params.total_score = String(this.sportsTotalScore);
            params.max_score = String(this.sportsTotalMaxScore);
        }
        if (this.isInspection) {
            params.total_score = String(this.inspectionTotalScore);
            params.max_score = '10';
        }

        const { code } = await wiz.call('submit_response', params);

        this.submitting = false;
        if (code === 200) {
            this.isSubmitted = true;
            this.response.status = 'submitted';
            await this.service.alert.show({
                title: '제출 완료',
                message: '점검 결과가 성공적으로 제출되었습니다.',
            });
        }
        this.ref.detectChanges();
    }

    // ==================== 유틸 ====================

    public facilityTypeLabel(type: string): string {
        const map: any = {
            bridge: '교량, 육교',
            tunnel: '터널, 지하차도',
            retaining_wall: '옹벽',
            cut_slope: '절토사면',
            building: '건축물, 지하도상가',
            soccer_field: '축구장',
            baseball_field: '야구장',
            indoor_arena: '실내경기장(배구, 농구)',
        };
        return map[type] || type || '-';
    }

    public statusLabel(status: string): string {
        const map: any = { draft: '작성 중', submitted: '제출 완료', reviewed: '리뷰 완료' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-yellow-50 text-yellow-700 border-yellow-200',
            submitted: 'bg-green-50 text-green-700 border-green-200',
            reviewed: 'bg-blue-50 text-blue-700 border-blue-200',
        };
        return map[status] || 'bg-slate-100 text-slate-500 border-slate-200';
    }

    public goBack() {
        this.service.href('/checklist/list');
    }

    // Generic 체크박스 옵션 토글
    public toggleCheckboxOption(itemId: string, option: string) {
        const answer = this.getAnswer(itemId);
        let selected: string[] = [];
        try {
            selected = answer.value ? JSON.parse(answer.value) : [];
        } catch { selected = []; }
        const idx = selected.indexOf(option);
        if (idx >= 0) {
            selected.splice(idx, 1);
        } else {
            selected.push(option);
        }
        answer.value = JSON.stringify(selected);
        this.scheduleAutoSave();
        this.ref.detectChanges();
    }

    // 답변 완성도 계산
    public get completionRate(): number {
        let total = 0;
        let answered = 0;
        for (const section of this.sections) {
            for (const item of section.items) {
                total++;
                const ans = this.answers[item.id];
                if (ans) {
                    if (ans.not_applicable) {
                        answered++;
                    } else if (this.isInspection) {
                        if (ans.grade) answered++;
                    } else if (this.isSports) {
                        if (ans.rating) answered++;
                    } else {
                        if (ans.value) answered++;
                    }
                }
            }
        }
        return total > 0 ? Math.round((answered / total) * 100) : 0;
    }
}

export default PageChecklistRespondComponent;